import { Pipe, PipeTransform } from '@angular/core';

import { DatepickerSettingModel } from './datepicker/datepicker.model';

export class CalendarSettingModel {
  optionsDMY: object = { year: 'numeric', month: 'long', day: 'numeric' };
  optionsMY: object = { year: 'numeric', month: 'long' };
  localeStr = 'ja-JP';
  localeJPStr = 'ja-JP-u-ca-japanese';

  constructor(
    public currentDate: Date,
    public title: string = '',
    public isNotDate: boolean = false,
    public dateRangeStart?: Date,
    public dateRangeEnd?: Date,
  ) {}
}

export class SelectedCellModel {
  day: Date | null;
  idxDay: number;
  idxWeek: number;
  isSetManual: boolean;
}

export class DayInMonth {
  date: Date;
  isInBound: boolean;
  day: number;
  isDisDay = false;
  hasData = false;

  get dateStr(): string {
    return this.date ? this.date.toLocaleDateString('fr-CA') : '';
  }
}

export class ExportCalendarModel {
  date: Date;
}

export class CalendarUtils {
  jpErasFunc = new DatepickerSettingModel();

  formatJPDate(date: Date, localeJPStr: string, optionsDMY: object, optionsMY: object) {
    const dateFormat = date.toLocaleDateString(localeJPStr, optionsDMY); //Example: 令和2年3月25日
    const yearArr = dateFormat.split('年');
    const jpEra = this.jpErasFunc.findEraYear(date);
    if (jpEra) {
      const eraNames = jpEra.name;
      const yearStr = Number(yearArr[0].replace(/^\D+/g, ''));
      const year = yearStr <= 9 ? '0' + yearStr : yearStr;
      const realMonth = date.getMonth() + 1;
      const month = realMonth <= 9 ? '0' + realMonth : realMonth;
      return eraNames + year + '年' + month + '月';
    } else {
      return date.toLocaleDateString(localeJPStr, optionsMY);
    }
  }

  formatJPDateEra(date: Date) {
    const optionsDMY: object = { year: 'numeric', month: 'long', day: 'numeric' };
    const optionsMY: object = { year: 'numeric', month: 'long' };
    const localeJPStr = 'ja-JP-u-ca-japanese';
    const dateFormat = date.toLocaleDateString(localeJPStr, optionsDMY); //Example: 令和2年3月25日
    const yearArr = dateFormat.split('年');
    const jpEra = this.jpErasFunc.findEraYear(date);
    if (jpEra) {
      const eraNames = jpEra.name;
      const yearStr = Number(yearArr[0].replace(/^\D+/g, ''));
      const yearVal = yearStr === 0 ? 1 : yearStr;
      const year = yearVal.toString().padStart(2, '0');
      const realMonth = date.getMonth() + 1;
      const month = realMonth.toString().padStart(2, '0');
      const realDay = date.getDate();
      const day = realDay.toString().padStart(2, '0');
      return eraNames + year + '年' + month + '月' + day + '日';
    } else {
      return date.toLocaleDateString(localeJPStr, optionsMY);
    }
  }

  formatJPStringDateCalender(date: Date) {
    if (!date) {
      return '';
    }
    date = new Date(date);
    const dateFormat = date.toLocaleDateString('ja-JP-u-ca-japanese', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
    const yearArr = dateFormat.split('年');
    const jpEra = this.jpErasFunc.findEraYear(date);
    if (jpEra) {
      const eraNames = jpEra.name;
      const yearStr = Number(yearArr[0].replace(/^\D+/g, ''));
      const year = yearStr <= 9 ? '0' + yearStr : yearStr;
      return eraNames + year + '年';
    } else {
      return '';
    }
  }

  selectedDay(cell: any, selectedCell: SelectedCellModel, inputDate: Date): boolean {
    try {
      if (selectedCell.idxDay !== -1) {
        return false;
      } else if (selectedCell.isSetManual) {
        if (
          cell.date.getFullYear() === selectedCell.day!.getFullYear() &&
          cell.date.getMonth() === selectedCell.day!.getMonth() &&
          cell.date.getDate() === selectedCell.day!.getDate()
        ) {
          return true;
        }
      } else {
        return (
          inputDate.getFullYear() === cell.date.getFullYear() &&
          inputDate.getMonth() === cell.date.getMonth() &&
          inputDate.getDate() === cell.date.getDate()
        );
      }
      return false;
    } catch (e) {
      return false;
    }
  }
}

@Pipe({
  name: 'formatJPDate',
})
export class FormatJPDate extends CalendarUtils implements PipeTransform {
  transform(value: any, date: Date, localeJPStr: string, optionsDMY: object, optionsMY: object) {
    return super.formatJPDate(date, localeJPStr, optionsDMY, optionsMY);
  }
}

@Pipe({
  name: 'formatJPDateEra',
})
export class FormatJPDateEra extends CalendarUtils implements PipeTransform {
  transform(date: Date) {
    return super.formatJPDateEra(date);
  }
}

@Pipe({
  name: 'selectedDay',
})
export class SelectedDay extends CalendarUtils implements PipeTransform {
  transform(value: any, cell: any, selectedCell: SelectedCellModel, inputDate: Date) {
    return super.selectedDay(cell, selectedCell, inputDate);
  }
}

@Pipe({
  name: 'JPStringDateCalender',
})
export class JPStringDateCalender extends CalendarUtils implements PipeTransform {
  transform(date: Date) {
    return super.formatJPStringDateCalender(date);
  }
}
